<template>
  <PflegeHero
    v-editable="props.blok"
    :data-uid="props.blok._uid"
    :heading="props.blok.heading"
    :subline="props.blok.subline"
    :subline-tag="props.blok.sublineTag"
    :text-align="props.blok.alignment"
    heading-tag="h1"
  >
    <template v-if="props.blok.media" #figure>
      <Media
        v-for="asset in props.blok.media"
        :key="asset._uid"
        :blok="asset"
        :aspect-ratio="{
          desktop: aspectRatios.xs,
          tablet: aspectRatios.s,
          mobile: aspectRatios.l
        }"
      />
    </template>
    <template v-if="props.blok.quickFacts && props.blok.quickFacts.length > 0" #quickFacts>
      <li v-for="item in props.blok.quickFacts" :key="item._uid" v-editable="item">
        <PflegeIcon :name="props.blok.quickFactsIcon" :color="props.blok.quickFactsIconColor" />
        <span>{{ item.label }}</span>
      </li>
    </template>
    <template v-if="props.blok.actions && props.blok.actions.length > 0" #actions>
      <Button v-for="button in props.blok.actions" :key="button._uid" :blok="button" />
    </template>
  </PflegeHero>
</template>

<script setup>
import { WPElementButton, WPElementMedia } from '@webcarelbj/shared-bloks'
import { findComponent } from '@webcarelbj/shared-components'

const Button = findComponent(WPElementButton)
const Media = findComponent(WPElementMedia)

const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
})
</script>
